export const CONTACT_FETCH_REQUESTED = 'CONTACT_FETCH_REQUESTED'
export const CONTACT_FETCH_SUCCESS = 'CONTACT_FETCH_SUCCESS'
export const ACTIVE_COMPANY_DEALS_FETCH_REQUESTED = 'ACTIVE_COMPANY_DEALS_FETCH_REQUESTED'
export const ACTIVE_COMPANY_DEALS_FETCH_SUCCESS = 'ACTIVE_COMPANY_DEALS_FETCH_SUCCESS'
export const REMOVE_DEAL_CONTACT_REQUESTED = 'REMOVE_DEAL_CONTACT_REQUESTED'
export const REMOVE_DEAL_CONTACT_SUCCESS = 'REMOVE_DEAL_CONTACT_SUCCESS'
export const CONTACT_UPDATE_REQUESTTED = 'CONTACT_UPDATE_REQUESTTED'
export const CONTACT_UPDATE_SUCCESS = 'CONTACT_UPDATE_SUCCESS'
export const CONTACT_DELETE_REQUESTED = 'CONTACT_DELETE_REQUESTED'
export const CONTACT_DELETE_SUCCESS = 'CONTACT_DELETE_SUCCESS'
export const EMAIL_CONTACT_REQUESTED = 'EMAIL_CONTACT_REQUESTED'
export const EMAIL_CONTACT_SUCCESS = 'EMAIL_CONTACT_SUCCESS'
export const CONTACT_NOTES_FETCH_REQUESTED = 'CONTACT_NOTES_FETCH_REQUESTED'
export const CONTACT_NOTES_FETCH_SUCCESS = 'CONTACT_NOTES_FETCH_SUCCESS'
export const CONTACT_ADD_NOTE_REQUESTED = 'CONTACT_ADD_NOTE_REQUESTED'
export const CONTACT_ADD_NOTE_SUCCESS = 'CONTACT_ADD_NOTE_SUCCESS'
export const CONTACT_DELETE_NOTE_REQUESTED = 'CONTACT_DELETE_NOTE_REQUESTED'
export const CONTACT_DELETE_NOTE_SUCCESS = 'CONTACT_DELETE_NOTE_SUCCESS'
export const CONTACT_UPDATE_NOTE_REQUESTED = 'CONTACT_UPDATE_NOTE_REQUESTED'
export const CONTACT_UPDATE_NOTE_SUCCESS = 'CONTACT_UPDATE_NOTE_SUCCESS'
